export const url = 'https://api.likemobile.am'
export const urlLink = 'https://api.likemobile.am'